<template>
  <div>
    <el-tooltip popper-class="is-green">
      <div class="tooltip-content" slot="content">
        <div v-if="disabled" class="stats">
          <div>{{ info.message }}</div>
          <div class="brand-list">
            <b>Current stats:</b>
            <span
              v-for="item in info.details"
              :key="item.brand"
            >
              - {{ item.brand }}:
              <b>{{ item.n_samples }}</b>
            </span>
          </div>
          <div>TOTAL: <b>{{ total }}</b></div>
        </div>
        <div v-else>
          <b>You can start retraining this model,</b> because you annotate more than 100 samples
        </div>
      </div>
      <div>
        <el-button
          class="open-modal"
          type="primary"
          :disabled="disabled"
          @click="openModal = true"
        >
          RETRAIN MODEL
          <svgicon name="Arrow-right" style="width: 14px;" />
        </el-button>
      </div>
    </el-tooltip>
    <el-dialog
      :visible.sync="openModal"
      title="Create new training"
      width="410px"
    >
      <form
        class="retrain-form"
        id="retrain"
        @submit.prevent="submit"
      >
        <div class="modal-field">
          <div class="modal-field__label acr-bold-16">Name</div>
          <el-input
            v-model="modelName"
            label="Project name"
            placeholder="Model name"
          />
        </div>
        <div class="modal-field">
          <div class="modal-field__header">
            <div class="modal-field__label acr-bold-16">Select a brand(s)</div>
            <el-button
              v-if="isShowSelectedAll"
              @click="handleSelectAll"
              size="medium"
              type="text"
            >
              Select all
            </el-button>
          </div>
          <el-select
            v-model="selectedBrands"
            :clearable="true"
            collapse-tags
            multiple
            placeholder="Select brands"
          >
            <el-option
              v-for="item in brandList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </form>
      <template slot="footer">
        <el-button @click="openModal = false">Cancel</el-button>
        <el-button
          form="retrain"
          native-type="submit"
          type="primary"
          :disabled="disabledSubmit"
          :loading="loading"
        >
          Start
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getBrands } from "@/api/dataset";
import { retrainModel } from "@/api/models";

export default {
  name: "RetrainModel",
  props: {
    disabled: {
      type: Boolean,
      required: true,
    },
    info: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      brandList: [],
      loading: false,
      modelName: '',
      selectedBrands: [],
      openModal: false,
    }
  },
  computed: {
    disabledSubmit() {
      return !(this.modelName && this.selectedBrands.length);
    },
    isSelectedAll() {
      return this.selectedBrands.length === this.brandList.length;
    },
    isShowSelectedAll() {
      return this.brandList.length && this.selectedBrands.length < this.brandList.length;
    },
    total() {
      if (!this.info.details) {
        return '-';
      }
      return this.info.details.reduce((res, cur) => res = res + cur.n_samples, 0)
    }
  },
  watch: {
    openModal(value) {
      if (value) {
        this.getDatasetBrands();
      }
    },
  },
  methods: {
    ...mapActions({
      error: 'error',
    }),
    async getDatasetBrands() {
      const { data = {} } = await getBrands();
      this.brandList = data.dataset_brands;
    },
    handleSelectAll() {
      this.selectedBrands = this.isSelectedAll ? [] : this.brandList.map(({ id }) => id);
    },
    async submit() {
      const formData = new FormData();
      const { projectId, videoId } = this.$route.params;
      formData.append('model_name', this.modelName);
      formData.append('brands_ids', this.selectedBrands.join(','));
      formData.append('project_id', projectId);
      formData.append('video_id', videoId);
      this.loading = true;

      try {
        const { data } = await retrainModel(formData);
        if (data.error) {
          this.error(data.msg);
        } else {
          this.$router.push({ name: 'projects' });
        }
        this.openModal = false;
        this.selectedBrands = [];
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style scoped lang="scss">
.tooltip-content {
  width: 260px;
  padding: 6px;
}

.stats {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.brand-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.retrain-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.open-modal {
  padding: 12px 18px;

  /deep/ {
    span {
      display: flex;
      gap: 6px;

      svg {
        width: 14px;
        height: 14px;
        transform: translateY(-1px);
      }
    }
  }
}

.modal-field__header {
  display: flex;

  button {
    margin-left: auto;
    color: inherit;
    padding: 0;
  }
}
</style>
